import $ from 'jquery';

document.addEventListener('tx.search.updated', function () {
    $('img[js-lazyload]').lazy({
        onError: function (el) {
            $(el).attr('src', $(el).data('default'));
        }
    });
});